import { Material, Mesh, MeshStandardMaterial, PlaneGeometry, Vector2, Vector3 } from "three";
import { ThreeService } from "../../rendering/threejs/three.service";


export class Plane {

  threeService: ThreeService
  geometry: PlaneGeometry
  material: Material
  mesh: Mesh

  constructor(threeService: ThreeService) {
    this.threeService = threeService
    this.geometry = new PlaneGeometry(1,1,10,10)
    this.material = new MeshStandardMaterial({
      color: 0x5e5e5e
    })
    this.mesh = new Mesh(this.geometry, this.material)
    threeService.addToScene(this.mesh)
  }

  updatePosition(camTarget: Vector3) {
    this.mesh.position.set(camTarget.x, camTarget.y, -10000)
    const width = 10000
    const worldWidth = this.threeService.pixelToObjectDistance(new Vector2(width, 0), this.mesh.position.z).x
    this.mesh.scale.set(worldWidth, worldWidth, worldWidth)

  }
  
}
